import { Component } from "@angular/core";
import * as Survey from "survey-angular";
import { FormGroup, FormControl, Validators, FormBuilder} from '@angular/forms';
import * as ClassicEditor from '@ckeditor/ckeditor5-build-classic';
// import CKFinder from '@ckeditor/ckeditor5-ckfinder/src/ckfinder';
import { Router } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';


@Component({
    selector: "Studentresponse-page",
    templateUrl: "./Studentresponse.page.html",
    styleUrls: ["./Student.css"],
})
export class StudentresponsePage {
    studentdata;
    studentuploads;
  uplodedfiles:any=[];
  AssignmentForm: FormGroup;
  teachername;
  filesize;
  filecount;
  filetype;
  instruction;
  stddescript;
  url;
  selected: any = { value: null };
  public Editor = ClassicEditor;
  constructor(private http: HttpClient,public router: Router,private formBuilder: FormBuilder) {
    this.getconfigkey().subscribe(data=>{
      this.url=data['resourseurl']
    
  })
    this.teachername=sessionStorage.getItem('teachername');
    if(this.teachername==undefined )
    {
      this.logout();
    }else{
    //   if(sessionStorage.getItem('jsondata')!=undefined){
    //     this.json=sessionStorage.getItem('jsondata');
    //   }else{
    //     this.json = json;
    //   }
    }    
  }
    ngOnInit() {
        this.studentdata = JSON.parse(sessionStorage.getItem("ReviewOrgJson1"));
        this.AssignmentForm = this.formBuilder.group({
            Astitle: ['', Validators.required],
            Lrnresponse: ['', Validators.required],
            Asscore: ['', Validators.required],
          fsize: ['', Validators.required],
          ftype: ['', Validators.required],
            fcount: ['', Validators.required]
          });
          this.AssignmentForm.disable();
          var previewdata = JSON.parse(sessionStorage.getItem("editdata"));
          this.previewAssignment(previewdata);
    }
    logout() {
        this.router.navigate(["/"]);
        sessionStorage.clear();
      }
    public checkError = (controlName: string, errorName: string) => {
        return this.AssignmentForm.controls[controlName].hasError(errorName);
      }
      previewAssignment(obj){
        if(obj !=null && obj.Filesize != null)
        {
        this.filesize =  obj.Filesize.split('$')[0];
        this.filetype = obj.Filesize.split('$')[1];
        this.filecount = obj.filecount;
        }
        else
        {
          this.filesize =  null;
          this.filetype = null;
          this.filecount = null;
        }
      this.AssignmentForm.patchValue({
        Astitle: obj.AssignmentTitle,
        Lrnresponse: obj.Learningresponse,
        Asscore: obj.Score,
        fsize: this.filesize,
        ftype: this.filetype,
        fcount: this.filecount
      });

      this.uplodedfiles =obj.resourcesinfo;
      this.studentuploads = this.studentdata.StudentUploads;
      this.instruction =obj.Description;
this.instruction=this.instruction.replace('<table>', '<table border="1">');
this.instruction=this.instruction.replace('<a', '<a target="_blanck"');
       
      this.stddescript =this.studentdata.studentDescription;
       this.stddescript=this.stddescript.replace('<table>', '<table border="1">');
       this.stddescript=this.stddescript.replace('<a', '<a target="_blanck"');  
      }
      public getconfigkey():any{            
        return this.http.get("assets/env.json");            
        }

      iframeurlset(fileitem)
      {
        console.log(this.url+fileitem.filename);
        window.open(this.url+fileitem.filename);
      }
      
}
